import type { ComponentStyleConfig } from '@chakra-ui/react';

export const Card: ComponentStyleConfig = {
    defaultProps: {
        variant: 'outline',
    },
};
